import type { Customer, CustomerQuery } from '../../api/customer';

export interface CustomerFilters {
  dioceseId: string;
}

export const EMPTY_CUSTOMER_FILTERS: CustomerFilters = {
  dioceseId: '',
};

export function countActiveCustomerFilters(filters: CustomerFilters): number {
  return filters.dioceseId ? 1 : 0;
}

export function customerFiltersToQueryParams(
  searchTerm: string,
  filters: CustomerFilters
): CustomerQuery {
  const query: CustomerQuery = {};
  const search = searchTerm.trim();
  if (search) {
    query.search = search;
  }
  if (filters.dioceseId) {
    query.diocese = filters.dioceseId;
  }
  return query;
}

export function getFullName(customer?: Customer | null): string {
  return `${customer?.title ?? ''} ${customer?.name ?? ''}`.trim();
}
